/**
 * Browser headset classification shared by XR entry and device-local defaults.
 *
 * `navigator.xr` is required: visionOS Safari intentionally presents a macOS
 * user agent, while iPhone, iPad, and macOS Safari expose no WebXR API. Quest
 * Browser is Chromium and identifies itself with `OculusBrowser`.
 *
 * Desktop browsers with an attached XR runtime may expose `navigator.xr`, so
 * that signal alone is not a headset-device test.
 */

export function isSafariLikeBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return /Safari\//.test(ua) && !/Chrome|Chromium|CriOS|Edg\/|OculusBrowser/.test(ua);
}

export function isHeadsetBrowser(): boolean {
  if (typeof navigator === "undefined" || !navigator.xr) return false;
  return isSafariLikeBrowser() || /OculusBrowser/.test(navigator.userAgent);
}
